export class BoletoValidar {
    folioBoleto: string;
} 